var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusBarPending = function SvgStatusBarPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324,
    height: 14,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 324,
    height: 12,
    y: 0.75,
    fill: "#3E4775",
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 0.25,
    y: 1.25,
    fill: "#B3A4FF",
    rx: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 3.25,
    y: 4.25,
    stroke: "#3E4775",
    strokeWidth: 2,
    rx: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 159,
    y: 4.25,
    stroke: "#CECEEB",
    strokeWidth: 2,
    rx: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 314.25,
    y: 3.75,
    stroke: "#CECEEB",
    strokeWidth: 2,
    rx: 3
  })));
};
export { SvgStatusBarPending as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzI0IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgMzI0IDE0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB5PSIwLjc1IiB3aWR0aD0iMzI0IiBoZWlnaHQ9IjEyIiByeD0iNiIgZmlsbD0iIzNFNDc3NSIvPgo8cmVjdCB4PSIwLjI1IiB5PSIxLjI1IiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHJ4PSI2IiBmaWxsPSIjQjNBNEZGIi8+CjxyZWN0IHg9IjMuMjUiIHk9IjQuMjUiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIzIiBzdHJva2U9IiMzRTQ3NzUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIxNTkiIHk9IjQuMjUiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIzIiBzdHJva2U9IiNDRUNFRUIiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIzMTQuMjUiIHk9IjMuNzUiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIzIiBzdHJva2U9IiNDRUNFRUIiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";